import { customFieldBuilderEs } from './custom-field-builder-i18n';
import { translationCenterEs } from './translation-center-i18n';
import { backupCenterEs, backupRestoreEs } from './backup-center-i18n';

/** Translations for the administration area; wired up in lib/i18n/en.ts. */
export const adminEs = {
  nav: {
    label: 'Administración',
    system: 'Sistema y telemetría',
    errorLogs: 'Centro de errores',
    customFields: 'Campos personalizados',
    auditVault: 'Bóveda de auditoría GoBD',
    dataHub: 'Importar y exportar',
    mailBackups: 'Envío de correo',
    backups: 'Centro de copias de seguridad',
    whatsapp: 'WhatsApp',
    telephonyAi: 'Telefonía e IA',
  },
  errorLogs: {
    title: 'Centro de errores',
    subtitle: 'Errores del sistema registrados centralmente con su contexto completo.',
    loadError: 'No se pudieron cargar los registros de errores.',
    emptyTitle: 'No se registraron errores',
    emptyHint: 'Ninguna entrada coincide con los filtros seleccionados.',
    kpi: {
      unresolved: 'Errores abiertos',
      last24h: 'Últimas 24 horas',
    },
    filters: {
      search: 'Buscar',
      searchPlaceholder: 'ID de seguimiento, mensaje o punto final',
      httpStatus: 'Estado HTTP',
      from: 'Desde',
      to: 'Hasta',
      unresolvedOnly: 'Solo no resueltos',
      reset: 'Restablecer filtros',
    },
    columns: {
      timestamp: 'Marca de tiempo',
      status: 'Estado',
      trackingId: 'ID de seguimiento',
      user: 'Usuario',
      endpoint: 'Punto final',
      message: 'Mensaje',
      state: 'Manejo',
    },
    state: {
      open: 'Abierto',
      resolved: 'Resuelto',
    },
    detail: {
      title: 'Detalles del error',
      ip: 'Dirección IP',
      client: 'Cliente',
      message: 'Mensaje',
      context: 'Contexto empresarial',
      payload: 'Datos de la solicitud',
      payloadHint: 'Contraseñas, tokens y datos bancarios se eliminan antes de almacenar.',
      stackTrace: 'Traza de pila',
      notes: 'Nota de resolución',
      resolved: 'El error fue marcado como resuelto.',
      reopened: 'El error se reabrió.',
      resolvedBy: 'Resuelto por {{name}} en {{date}}.',
    },
    actions: {
      resolve: 'Marcar como resuelto',
      reopen: 'Reabrir',
      openDocument: 'Abrir documento afectado',
      export: 'Exportar informe de soporte',
    },
  },
  status: {
    OK: 'OK',
    WARNING: 'Advertencia',
    CRITICAL: 'Crítico',
  },
  system: {
    title: 'Sistema y telemetría',
    subtitle: 'Tiempo de ejecución, base de datos y servidor de un vistazo.',
    error: 'No se pudo cargar la telemetría.',
    refresh: 'Actualizar',
    application: 'Aplicación',
    database: 'Base de datos',
    server: 'Servidor',
    version: 'Versión',
    commit: 'Confirmar',
    node: 'Node.js',
    environment: 'Entorno',
    uptime: 'Tiempo de actividad',
    heap: 'Heap',
    dbSize: 'Tamaño de la base de datos',
    connections: 'Conexiones',
    streamClients: 'Clientes activos',
    scheduler: 'Trabajos en segundo plano',
    schedulerStopped: 'No en ejecución',
    auditEntries: 'Entradas de auditoría',
    cores: 'Núcleos de CPU',
    loadAverage: 'Promedio de carga',
    memory: 'Memoria',
    backupDisk: 'Almacenamiento de respaldo',
    unavailable: 'No disponible',
    collectedAt: 'Recopilado en',
    cpu: 'Carga de CPU',
    eventLoop: 'Bucle de eventos {{value}} ms',
    cacheHit: 'Proporción de aciertos de caché {{value}} %',
    gauges: 'Utilización',
    gaugesHint: 'Los valores se actualizan cada 15 segundos.',
    features: 'Funciones y módulos',
    featuresHint: 'Disponibilidad efectiva, errores de configuración y trabajos pausados.',
    featuresActive: 'Activos',
    featuresDisabled: 'Desactivados',
    featuresMisconfigured: 'Mal configurados',
    featuresBlocked: 'Dependencias bloqueadas',
    featuresPausedJobs: 'Trabajos pausados',
    featuresLastChanges: 'Últimos cambios',
    featuresNoChanges: 'No hay cambios registrados.',
    featureActive: 'activo',
    featureInactive: 'inactivo',
    quickActions: 'Acciones rápidas',
    quickActionsHint: 'Tareas de mantenimiento y cachés.',
    clearCache: 'Borrar caché',
    cacheCleared: 'Archivos almacenados en caché de {{count}} eliminados.',
    maintenanceMode: 'Modo de mantenimiento',
    maintenanceHint: 'Bloquea la aplicación para todos excepto las direcciones permitidas.',
    maintenanceMessage: 'Aviso',
    allowedIps: 'Direcciones IP permitidas',
    allowedIpsHint: 'Separadas por comas, se permiten rangos CIDR como 10.0.0.0/8.',
    maintenanceSaved: 'Configuración guardada.',
  },
  customFields: {
    ...customFieldBuilderEs,
    translationCenter: translationCenterEs,
    title: 'Campos personalizados',
    subtitle: 'Campos propios por área de datos, sin cambios de código.',
    create: 'Nuevo campo personalizado',
    created: 'Campo personalizado creado.',
    updated: 'Campo personalizado guardado.',
    archived: 'Campo personalizado archivado.',
    empty: 'Aún no hay campos personalizados',
    emptyHint: 'Cree un campo para capturar información adicional.',
    dialogTitle: 'Crear campo personalizado',
    editTitle: 'Editar campo personalizado',
    edit: 'Editar',
    dialogDescription: 'El campo aparece en los formularios de {{entity}}.',
    label: 'Nombre para mostrar',
    key: 'Clave',
    keyHint: 'Nombre técnico; fijo después de la creación.',
    description: 'Descripción',
    group: 'Categoría',
    groupPlaceholder: 'Seleccionar categoría',
    type: 'Tipo de dato',
    pattern: 'Expresión regular de validación',
    patternHint: 'Verificación de formato opcional, p. ej. ^[A-Z]{2}\\d{4}$.',
    options: 'Opciones',
    optionLabel: 'Etiqueta de opción',
    addOption: 'Agregar opción',
    removeOption: 'Eliminar opción',
    noOptions: 'Aún no hay opciones',
    required: 'Requerido',
    inPdf: 'Imprimir en PDF',
    searchable: 'Buscable',
    marketingSegmentationAllowed: 'Aprobar para segmentación de boletines',
    marketingSegmentationHint: 'Activar solo tras revisión y para campos no sensibles.',
    inList: 'Mostrar en tablas',
    inherit: 'Trasladar a documentos de seguimiento',
    inheritHint: 'El valor sigue automáticamente cotización → pedido → albarán → factura.',
    inherited: 'Heredado',
    inItemTable: 'Mostrar en la tabla de artículos',
    inItemTableHint: 'Aparece debajo de la fila del artículo y en el PDF.',
    copyFromProduct: 'Copiar valor del producto en el artículo',
    copyFromProductHint:
      'Al agregar el producto, se copia el valor de sus datos principales en el artículo del documento.',
    documentTypesTitle: 'Válido para tipos de documentos',
    documentTypesHint: 'Sin selección, el campo se aplica a todos los tipos de documentos.',
    preview: 'Vista previa en vivo',
    previewHint: 'Así es como aparece el campo en el formulario.',
    previewLabel: 'Nuevo campo',
    moveUp: 'Mover hacia arriba',
    moveDown: 'Mover hacia abajo',
    archive: 'Archivar',
    archiveTitle: 'Archivar campo personalizado',
    archiveDescription: 'El campo “{{label}}” está oculto; los valores capturados permanecen.',
    entities: {
      CUSTOMER: 'Socios comerciales',
      CONTACT: 'Personas de contacto',
      ADDRESS: 'Direcciones y direcciones de entrega',
      PRODUCT: 'Productos',
      PRODUCT_PACKAGING: 'Embalajes de productos',
      DOCUMENT: 'Encabezado del documento',
      DOCUMENT_ITEM: 'Fila de elemento del documento',
      BATCH: 'Lotes',
    },
    documentTypes: {
      QUOTE: 'Cotización',
      ORDER: 'Pedido',
      DELIVERY_NOTE: 'Nota de entrega',
      INVOICE: 'Factura',
      PURCHASE_ORDER: 'Orden de compra',
    },
    formula: {
      title: 'Fórmula',
      expression: 'Expresión',
      expressionHint:
        'Se permiten + - * / paréntesis, || para valores de respaldo y abs, min, max, round, floor y ceil.',
      invalid: 'La fórmula no es válida.',
      unit: 'Unidad',
      unitHint: 'Mostrado después del resultado, por ejemplo, €/ud.',
      decimals: 'Decimales',
      testTitle: 'Prueba en vivo',
      result: 'Resultado',
      variables: {
        title: 'Variables disponibles – haga clic para insertar',
        quantity: 'Cantidad',
        unitPrice: 'Precio unitario',
        discountPercent: 'Descuento %',
        taxRate: 'Tasa impositiva',
        lineNet: 'Neto de la línea',
        lineGross: 'Bruto de la línea',
        lineTotal: 'Total de la línea',
      },
    },
    types: {
      WEEKLY_SCHEDULE: 'Días de la semana y horarios',
      TEXT: 'Texto',
      TEXTAREA: 'Texto multilínea',
      NUMBER: 'Entero',
      DECIMAL: 'Decimal',
      DATE: 'Fecha',
      CHECKBOX: 'Sí/No',
      SELECT: 'Elección simple',
      MULTI_SELECT: 'Elección múltiple',
      FORMULA: 'Campo calculado',
    },
  },
  auditVault: {
    title: 'Bóveda de auditoría GoBD',
    subtitle: 'Completo, historial de cambios encadenado criptográficamente.',
    error: 'No se pudo cargar el registro.',
    empty: 'No hay entradas para los filtros seleccionados.',
    integrityTitle: 'Integridad y exportación de datos fiscales',
    integrityHint:
      'La verificación recalcula cada hash e informa discrepancias y números faltantes.',
    verify: 'Verificar cadena de hash',
    exportCsv: 'Exportación GoBD (CSV)',
    exportXml: 'Exportación GDPdU (XML)',
    exportReady: 'Exportación creada.',
    intact: 'Todas las entradas {{count}} están sin alterar.',
    broken: 'Se encontraron violaciones de integridad {{count}}.',
    verifiedAt: 'Verificado en {{timestamp}} en {{duration}} ms.',
    headHash: 'Suma de verificación principal',
    filterEntity: 'Filtrar entidad',
    filterAction: 'Filtrar acción',
    allEntities: 'Todas las entidades',
    allActions: 'Todas las acciones',
    from: 'Desde',
    to: 'Hasta',
    timestamp: 'Marca de tiempo',
    action: 'Acción',
    entity: 'Entidad',
    user: 'Usuario',
    hash: 'Suma de verificación',
    previousHash: 'Predecesor',
    origin: 'Origen',
    diffTitle: 'Entrada de registro #{{sequence}}',
    field: 'Campo',
    before: 'Antes',
    after: 'Después',
    noPayload: 'Esta acción no tiene carga útil.',
    changedFields: '{{count}} de {{total}} campos modificados.',
    actions: {
      INSERT: 'Creado',
      UPDATE: 'Actualizado',
      DELETE: 'Eliminado',
      LOCK: 'Bloqueado',
      EXPORT: 'Exportado',
      REVERT: 'Revertido',
    },
    breaches: {
      HASH_MISMATCH: 'La suma de verificación no coincide con la carga útil.',
      CHAIN_BROKEN: 'El enlace al predecesor está roto.',
      SEQUENCE_GAP: 'Hueco en los números de secuencia.',
    },
    entities: {
      Customer: 'Cliente',
      Product: 'Producto',
      ProductBatch: 'Lote',
      Document: 'Documento',
      DocumentItem: 'Elemento del documento',
      StockMovement: 'Movimiento de stock',
      DatevExportLog: 'Exportación DATEV',
      IntrastatExportLog: 'Exportación Intrastat',
      CompanyProfile: 'Perfil de empresa',
      CustomFieldDefinition: 'Campo personalizado',
      VatIdVerification: 'Prueba de validación del NIF-IVA',
      DunningSettings: 'Configuración de cobros',
      DunningStage: 'Nivel de aviso',
      CustomerDunningPolicy: 'Condiciones de cobro del cliente',
      DunningRun: 'Ejecución de avisos',
      DunningNotice: 'Recordatorio de pago',
      DunningNoticeSnapshot: 'Instantánea aprobada del aviso',
      DunningNoticeItem: 'Partida abierta reclamada',
      DunningStatusEvent: 'Prueba de estado del aviso',
      DunningDispatch: 'Prueba de envío del aviso',
      CustomerPayment: 'Pago de cliente',
      CustomerPaymentAllocation: 'Asignación de pago',
      VatValidationSettings: 'Configuración de validación del NIF-IVA',
      ProductionLotGenealogyEdge: 'Enlace de genealogía de lotes',
      RecallSimulation: 'Simulación de retirada',
      RecallSimulationAnchor: 'Lote inicial de retirada',
      RecallSimulationAffectedBatch: 'Lote afectado por la retirada',
      RecallSimulationOperation: 'Operación de retirada',
    },
  },
  dataHub: {
    title: 'Importar y exportar',
    subtitle: 'Tomar los datos maestros de archivos CSV o Excel.',
    step1: 'Elegir archivo',
    step1Hint: 'CSV o Excel mediante arrastrar y soltar o el selector de archivos.',
    step2: 'Asignar columnas',
    step2Hint: 'Las columnas con nombres coincidentes se asignan automáticamente.',
    step3: 'Validar e importar',
    step3Hint: 'La ejecución de prueba no escribe nada en la base de datos.',
    target: 'Área de destino',
    dropHere: 'Suelta el archivo aquí',
    formats: 'Compatible con .csv y .xlsx hasta 10 MB.',
    chooseFile: 'Elegir archivo',
    uploaded: '{{fileName}} · {{rows}} filas, {{columns}} columnas detectadas.',
    sourceColumn: 'Columna de origen',
    sample: 'Valores de muestra',
    targetField: 'Campo ERP',
    ignore: 'No importar',
    runDryRun: 'Iniciar ejecución de prueba',
    validRows: '{{count}} filas válidas',
    invalidRows: '{{count}} filas inválidas',
    row: 'Fila',
    field: 'Campo',
    reason: 'Razón',
    startImport: 'Importar {{count}} filas',
    imported: 'Se crearon {{success}} registros, se omitieron {{failed}}.',
    history: 'Historial de importación',
    historyHint: 'Las ejecuciones completadas se pueden revertir por completo.',
    noJobs: 'Aún no hay ejecuciones de importación.',
    file: 'archivo',
    progress: 'Progreso',
    status: 'Estado',
    executedAt: 'Completado',
    rowSummary: '{{success}} importado · {{failed}} errores · {{total}} en total',
    rollback: 'Revertir',
    rolledBack: 'Importación revertida.',
    entities: {
      CUSTOMER: 'Clientes',
      PRODUCT: 'Productos',
      STOCK_ADJUSTMENT: 'Ajustes de inventario',
    },
    statuses: {
      PENDING: 'Pendiente',
      PROCESSING: 'En ejecución',
      COMPLETED: 'Completado',
      FAILED: 'Fallido',
      ROLLED_BACK: 'Revertido',
    },
  },
  backupCenter: backupCenterEs,
  backupRestore: backupRestoreEs,
  mailBackups: {
    title: 'Envío de correo',
    subtitle: 'Verificar correo saliente y configuración SMTP.',
    smtpTitle: 'Diagnóstico SMTP',
    smtpHint: 'Verifica la conexión, cifrado y autenticación en el servidor de correo.',
    testConnection: 'Probar conexión',
    sendTest: 'Enviar mensaje de prueba',
    recipient: 'Destinatario',
    testSent: 'Mensaje de prueba enviado.',
    testFailed: 'No se pudo enviar el mensaje de prueba.',
    reachable: 'Alcanzable',
    unreachable: 'Inalcanzable',
    queueTitle: 'Correos de documentos fallidos',
    queueHint: 'El reenvío está disponible directamente en el documento.',
    queueEmpty: 'No hay entregas fallidas.',
    document: 'Documento',
    errorMessage: 'Error',
    attemptedAt: 'Intentado en',
    backupsTitle: 'Copias de seguridad',
    backupsHint: 'Archivos cifrados (AES-256-GCM) en el directorio de copias de seguridad.',
    createNow: 'Crear copia de seguridad ahora',
    backupCreated: 'Copia de seguridad creada.',
    noBackups: 'Aún no hay copias de seguridad disponibles.',
    archive: 'Archivar',
    size: 'Tamaño',
    createdAt: 'Creado en',
    checksum: 'Suma de verificación',
    download: 'Descargar',
    delete: 'Eliminar',
    deleted: 'Copia de seguridad eliminada.',
    deleteTitle: '¿Eliminar copia de seguridad?',
    deleteDescription:
      'El archivo "{{fileName}}" se eliminará permanentemente del servidor. Las copias ya descargadas permanecerán sin cambios.',
    writable: 'Directorio escribible',
    notWritable: 'Directorio no escribible',
    dumpAvailable: 'pg_dump disponible',
    dumpMissing: 'pg_dump ausente — las copias de seguridad se ejecutan mediante el cron del host',
    cron: 'Programa (cron)',
    retention: 'Retención (días)',
    storageTarget: 'Almacenamiento objetivo',
    encrypted: 'Cifrado',
    scheduleActive: 'Programación activa',
    lastRun: 'Último ejecución: {{timestamp}} · {{status}}',
    targets: {
      LOCAL: 'Volumen local',
      S3: 'Compatibilidad con S3',
      OFFSITE_SSH: 'Almacenamiento de SSH fuera de sitio',
    },
  },
} as const;
